import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.css']
})
export class StorageComponent implements OnInit {

  storageConfNavTab:string = 's3Bucket';

  constructor() { }

  ngOnInit() {
  }

}
